import type { TFunction } from 'i18next';

/** 存储回收策略默认值；SKU / 下单锁定时强制写入 */
export const DEFAULT_RECLAIM_POLICY = 'Delete';

export function getReclaimPolicyDescriptions(t: TFunction): Record<string, string> {
  return {
    Delete: t(
      'components:automatically.delete.cloud.disk.resources.when.they.are.unbound.from.instances.such.as.deleting.instances.changing.images.or.modifying.data.disks',
    ),
    Retain: t(
      'components:retain.cloud.disk.resources.when.they.are.unbound.from.instances.such.as.deleting.instances.changing.images.or.modifying.data.disks',
    ),
  };
}
